import React, { useEffect, useRef, useState } from "react";
import CustomCard from "../../../components/d-reusable/CustomCard";
import "./style.css";
import CustomFilter from "../../../components/d-reusable/CustomFilter";
import { Col, message, Modal, Popconfirm, Row, Table } from "antd";
import { dentalIcons } from "../../../utils-icons/dentalIcons";
import CustomLinkButton from "../../../components/d-reusable/CustomLinkButton";
import CustomPrimaryButton from "../../../components/d-reusable/CustomPrimaryButton";
import CustomSearchInput from "../../../components/d-reusable/CustomSearchInput";
import CustomSpiner from "../../../components/d-reusable/CustomSpiner";
import CustomDrawer from "../../../components/d-reusable/CustomDrawer";
import { useLocation, useNavigate, useParams } from "react-router";
import {
  countForGenderAndProgress,
  dentalBasePath,
  errorRequestHandel,
  filterAmCaseAddedByACollaborator,
  filterAmPmDentalRecordAddedByCollaborator,
  filterPmCaseAddedByACollaborator,
  formateDateAndTime,
  getAgeValidationTag,
  getMyInfoFromProjectCollaborators,
  getPendingRecords,
  getProjectCode,
  projectStatuses,
  transformQuadrantData,
  transformServerDataToMarkedTeeth,
} from "../../../../helper";
import CustomDropdown from "../../../components/d-reusable/CustomDropdown";
import TotalCases from "./child-components/TotalCases";
import DentalRecords from "./child-components/DentalRecords";
import AddCollaborator from "../add-collaborator/AddCollaborator";
import SingleCaseDetails from "./child-components/case-details/SingleCaseDetails";
import { useDispatch, useSelector } from "react-redux";
import {
  _onDentalRecordScreen,
  _setMyInfo,
  _setProjectDetailsCaseTab,
  _setProjectDetailsTab,
  _setisProjectOpenForCollaboration,
  _toggleEditCaseState,
  _toggleEditState,
} from "../../../../redux/actions/generalAction";
import {
  deleteAM_Or_PmCaseForCurrentProject,
  findDentalIndentificationProject,
  onAddExaminarToProject,
  onDeleteExaminarFromProject,
  updateProjectStatus,
} from "../../../../components/https/projects-apis";
import {
  _clearFormData,
  _onSetAmFormData,
  _onSetPmFormData,
} from "../../../../redux/actions/caseAction";
import {
  _onClearDentalRecordData,
  _onRecordUpdate,
  _onSetDentalRecordDataForUpdate,
} from "../../../../redux/actions/dentalRecordAction";
import ProjectTraceability from "./child-components/project-traceability/ProjectTraceability";
import ActionModal from "./child-components/modals/ActionModal";
import moment from "moment";
import { get, onChildAdded, ref } from "firebase/database";
import { database } from "../../../../firebase";
import { IdentificationStatusInfo } from "../../../components/d-reusable/IdentificationStatusInfo";

const filters = [
  {
    id: 1,
    title: "Case Analysis",
    value: "details",
  },
  {
    id: 2,
    title: "Case Management",
    value: "cases",
  },
  {
    id: 3,
    title: "Case Collaboration",
    value: "collaborators",
  },
  {
    id: 4,
    title: "Case Traceability",
    value: "traceability",
  },
];
const amPmCasesTabs = [
  {
    id: 1,
    title: "All Cases",
    value: "all",
  },
  {
    id: 2,
    title: "Ante-Mortem (AM) Cases",
    value: "am",
  },
  {
    id: 3,
    title: "Post-Mortem (PM) Cases",
    value: "pm",
  },
];

const ProjectDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userdata = useSelector(
    (state) => state.settings_data.profileSettings_data
  );

  const location = useLocation();
  const id = location.state?.projectId; // Get caseId from state

  const [loading, setLoading] = useState(true);
  const [loadingItemId, setLoadingItemId] = useState(null);

  const selectedProjectDetailTab = useSelector(
    (state) => state.general?.selectedProjectDetailTab || "details"
  );
  const myInfo = useSelector((state) => state.general?.myInfo || null);
  const isProjectOpenForCollaboration = useSelector(
    (state) => state.general?.isProjectOpenForCollaboration || false
  );
  const selectedProjectDetailCaseTab = useSelector(
    (state) => state.general?.selectedProjectDetailCaseTab || "all"
  );
  const [open, setOpen] = useState(false);
  const [caseDetails, setCaseDetails] = useState(null);
  const [caseDetailOpen, setCaseDetailOpen] = useState(false);
  const [projectDetail, setProjectDetail] = useState(null);
  const [projectStatus, setProjectStatus] = useState("");
  const [projectStatusAction, setProjectStatusAction] = useState("");
  const [searchExaminar, setSearchExaminar] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);
  const currentUserId = useSelector((state) => state.auth?.user?.id);

  const lastProjectIdRef = useRef(null);

  useEffect(() => {
    const simulationsRef = ref(database, "simulations_records");

    const unsubscribe = onChildAdded(simulationsRef, async (snapshot) => {
      const snapshotChild = snapshot.val();

      if (
        snapshotChild?.project_id == id &&
        lastProjectIdRef.current !== snapshotChild.id
      ) {
        lastProjectIdRef.current = snapshotChild.id;
        await getProjectDetails();
      }
    });

    return () => unsubscribe();
  }, []);

  const getProjectDetails = async () => {
    dispatch(_onClearDentalRecordData());
    try {
      setLoading(true);
      const response = await findDentalIndentificationProject({ id: id });
      if (response.status === 200) {
        const collaborators = response.data.data.collaborators;

        if (!Array.isArray(collaborators) || collaborators.length === 0)
          return null;

        const user = collaborators.find(
          (collaborator) => collaborator.id === userdata?.id
        );
        if (user) {
          dispatch(_setMyInfo(user));
        }
        dispatch(
          _setisProjectOpenForCollaboration(response?.data?.data.is_open)
        );
        setProjectDetail(response.data?.data);
        setProjectStatus(response.data?.data?.status);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      errorRequestHandel({ error });
    }
  };

  useEffect(() => {
    getProjectDetails();
  }, []);

  const isPrimaryExaminer = () => {
    const currentUser = projectDetail?.collaborators?.find(
      (collab) => collab.id === currentUserId
    );
    return currentUser?.examiner_type === "primary";
  };

  const renderCaseView = (type) => {
    switch (type) {
      case "details":
        return renderPojectDetailTab();
        break;
      case "cases":
        return renderAmPmCasesTab();
        break;
      case "collaborators":
        return renderCollaboratorsTab();
        break;
      case "traceability":
        return renderTraceabilityTab();
        break;

      default:
        return renderPojectDetailTab();
        break;
    }
  };

  const amCases = projectDetail?.cases.filter(
    (caseItem) => caseItem.case_type === "am"
  ).length;

  const pmCases = projectDetail?.cases.filter(
    (caseItem) => caseItem.case_type === "pm"
  ).length;

  const count = countForGenderAndProgress(projectDetail?.cases || []);

  const renderPojectDetailTab = () => {
    return (
      <div>
        <Table
          dataSource={[...(projectDetail?.simulations || [])].sort(
            (a, b) => b.score - a.score
          )}
          style={{ overflowX: "scroll" }}
          columns={[
            {
              title: "AM Case",
              key: "id",
              render: (text, record) => {
                return (
                  <div className="custom_table_row_data">
                    <p className="_title">{record.am_case?.full_name}</p>
                  </div>
                );
              },
            },
            {
              title: "PM Case",
              key: "pm_case",
              render: (text, record) => {
                return (
                  <div className="custom_table_row_data">
                    <p className="_title">
                      {record.pm_case?.temporary_identifier}
                    </p>
                  </div>
                );
              },
            },

            {
              title: <div className="custom_header_col">Score</div>,
              key: "highestScore",
              onCell: (_, rowIndex) => ({
                className: `column-${1}`,
              }),
              onHeaderCell: () => ({
                className: `column-${1}`,
              }),
              render: (text, record) => (
                <div className="center_align_digits">{record?.score}</div>
              ),
            },
            {
              title: <div className="custom_header_col">Matches</div>,
              key: "matchCount",
              onCell: (_, rowIndex) => ({
                className: `column-${2}`,
              }),
              onHeaderCell: () => ({
                className: `column-${2}`,
              }),
              render: (text, record) => (
                <div className="center_align_digits">{record?.match_count}</div>
              ),
            },

            {
              title: <div className="custom_header_col">Possible Matches</div>,
              key: "possibleMatches",
              onCell: (_, rowIndex) => ({
                className: `column-${3}`,
              }),
              onHeaderCell: () => ({
                className: `column-${3}`,
              }),
              render: (text, record) => (
                <div className="center_align_digits">
                  {record?.possible_match_count}
                </div>
              ),
            },
            {
              title: <div className="custom_header_col">Mismatches</div>,
              key: "mismatchCount",
              onCell: (_, rowIndex) => ({
                className: `column-${4}`,
              }),
              onHeaderCell: () => ({
                className: `column-${4}`,
              }),
              render: (text, record) => (
                <div className="center_align_digits">
                  {record?.mismatch_count}
                </div>
              ),
            },
            // {
            //   title: <div className="custom_header_col">Identity Status</div>,
            //   // dataIndex: "forensic_match",
            //   key: "forensic_match",
            //   render: (text, record) => {
            //     // Ensure correct destructuring: text, record

            //     return (
            //       <div>
            //         {" "}
            //         <IdentificationStatusTag status={record?.forensic_match} />
            //         <div style={{ marginTop: 5 }}>
            //           {getAgeValidationTag(record?.am_case, record?.pm_case)}
            //         </div>
            //       </div>
            //     );
            //   },
            // },

            {
              title: <div className="custom_header_col">Identity Status</div>,
              key: "forensic_match",
              render: (text, record) => (
                <IdentificationStatusInfo
                  status={record?.forensic_match || "Manual Review"}
                  extraBelow={getAgeValidationTag(
                    record?.am_case,
                    record?.pm_case
                  )}
                />
              ),
            },
            {
              title: <div className="custom_header_col">Record Comparison</div>,
              dataIndex: "action",
              key: "action",
              render: (text, record) => {
                // Ensure correct destructuring: text, record

                return (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      fontSize: 12,
                      color: "#20C3FF",
                      gap: 5,
                    }}
                  >
                    <div
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={() =>
                        navigate(
                          `${dentalBasePath}/projects/details/case/results/${record.id}`
                        )
                      }
                    >
                      <img
                        src={dentalIcons.viewIcon}
                        alt="Share"
                        style={{ cursor: "pointer", paddingRight: 4 }}
                      />
                    </div>
                  </div>
                );
              },
            },
            {
              title: <div className="custom_header_col">PM Investigation</div>,
              dataIndex: "action",
              key: "action",
              render: (text, record) => {
                // Ensure correct destructuring: text, record

                return (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      fontSize: 12,
                      color: "#20C3FF",
                      gap: 5,
                    }}
                  >
                    <div
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={() =>
                        navigate(
                          `${dentalBasePath}/projects/details/case/all-records/${record.pm_case_id}`
                        )
                      }
                    >
                      <img
                        src={dentalIcons.viewIcon}
                        alt="Share"
                        style={{ cursor: "pointer", paddingRight: 4 }}
                      />
                    </div>
                  </div>
                );
              },
            },
          ]}
          pagination={false}
        />
      </div>
    );
  };

  const renderAmPmCasesTab = () => {
    const updatedCases = projectDetail?.cases.filter((caseItem) =>
      selectedProjectDetailCaseTab === "all"
        ? true
        : caseItem.case_type === selectedProjectDetailCaseTab
    );
    const { amPendingRecordCount, pmPendingRecordCount } =
      getPendingRecords(projectDetail);

    return (
      <div className="d-am_pm_case_tab">
        <div className="d-am_pm_case_tab_graph">
          <Row gutter={[10, 10]}>
            <Col md={12}>
              <TotalCases
                isOpenSearch={projectDetail?.incident_type === "open_search"}
                caseTitle={"Total AM"}
                type={"AM"}
                totalCases={projectDetail?.total_am_cases}
                cases={projectDetail?.cases || []}
                pending={projectDetail?.cases.length - amCases}
                added={amCases}
                count={count?.am}
              />
            </Col>
            <Col md={12}>
              <TotalCases
                isOpenSearch={projectDetail?.incident_type === "open_search"}
                caseTitle={"Total PM"}
                type={"PM"}
                totalCases={projectDetail?.total_pm_cases}
                cases={projectDetail?.cases || []}
                pending={projectDetail?.cases.length - pmCases}
                added={pmCases}
                count={count?.pm}
              />
            </Col>
          </Row>
        </div>
        <br />
        <div style={{ marginLeft: 20 }}>
          <CustomFilter
            filtersData={amPmCasesTabs}
            customClass={"custom-width"}
            selectedTab={selectedProjectDetailCaseTab}
            onSelect={(value) => dispatch(_setProjectDetailsCaseTab(value))}
          />
        </div>
        <div className="d_am_pm_tabs_section">
          <Row gutter={[10, 20]}>
            <Col>
              {(myInfo?.canManageAmCases || isProjectOpenForCollaboration) && (
                <CustomPrimaryButton
                  isDisbale={
                    projectDetail?.status == "archived" ||
                    projectDetail?.status == "completed"
                  }
                  title="Add AM Case"
                  onClick={() => {
                    navigate(
                      `${dentalBasePath}/projects/details/case-registration/am`,
                      {
                        state: { type: "am", projectId: projectDetail?.id },
                      }
                    );
                    dispatch(_clearFormData());
                    dispatch(_toggleEditCaseState(false));
                  }}
                  width={100}
                  isFirst={true}
                  leadingIcon={false}
                />
              )}
            </Col>
            <Col>
              {(myInfo?.canManagePmCases || isProjectOpenForCollaboration) && (
                <CustomPrimaryButton
                  isPm={true}
                  isDisbale={
                    projectDetail?.status === "archived" ||
                    projectDetail?.status === "completed"
                  }
                  title="Add PM Case"
                  onClick={() => {
                    navigate(
                      `${dentalBasePath}/projects/details/case-registration/pm`,
                      {
                        state: { type: "pm", projectId: projectDetail?.id },
                      }
                    );
                    dispatch(_clearFormData());
                    dispatch(_toggleEditCaseState(false));
                  }}
                  width={100}
                  leadingIcon={false}
                />
              )}
            </Col>
          </Row>
        </div>
        <br />

        <Table
          dataSource={updatedCases}
          style={{ overflowX: "scroll" }}
          columns={[
            {
              title: "Case No",
              dataIndex: "case_number",
              key: "case_number",
            },
            {
              title: "Type",
              key: "case_type",
              render: (t, record) => record?.case_type.toUpperCase(),
            },

            ...(selectedProjectDetailCaseTab === "all"
              ? [
                  {
                    title: "Name / Identifier Victim",
                    key: "date_of_accident",
                    render: (text, record) =>
                      record?.temporary_identifier
                        ? record?.temporary_identifier
                        : record?.full_name,
                  },
                ]
              : [
                  selectedProjectDetailCaseTab === "pm"
                    ? {
                        title: "Temporary Identifier",
                        dataIndex: "temporary_identifier",
                        key: "temporary_identifier",
                      }
                    : {
                        title: "Name",
                        dataIndex: "full_name",
                        key: "full_name",
                      },
                ]),
            {
              title: "Gender",
              dataIndex: "gender",
              key: "gender",
            },

            {
              title: "View Case",
              key: "addedBy",
              align: "center",
              render: (t, record) => {
                return (
                  <div
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={() => handleOpenSingleCaseDetail(record)}
                  >
                    <img
                      src={dentalIcons.viewIcon}
                      alt="Share"
                      style={{ cursor: "pointer", paddingRight: 4 }}
                    />
                  </div>
                );
              },
            },
            {
              title: "Edit Case",
              key: "addedBy",
              align: "center",
              render: (t, record) => {
                const isAmCase = record.case_type === "am";
                const isPmCase = record.case_type === "pm";
                const canManage =
                  (isAmCase && myInfo?.canManageAmCases) ||
                  (isPmCase && myInfo?.canManagePmCases) ||
                  isProjectOpenForCollaboration;
                return (
                  <div
                    style={{
                      display: "flex",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 10,
                    }}
                  >
                    {canManage && (
                      <img
                        onClick={() => {
                          if (record.case_type === "am") {
                            if (
                              myInfo.canManageAmCases ||
                              isProjectOpenForCollaboration
                            ) {
                              dispatch(_onSetAmFormData(record));
                              dispatch(_toggleEditCaseState(true));
                              navigate(
                                `${dentalBasePath}/projects/details/case-registration/am`,
                                {
                                  state: {
                                    caseId: record?.id,
                                    type: "am",
                                    projectId: projectDetail?.id,
                                  },
                                }
                              );
                            } else return;
                          } else {
                            if (
                              myInfo.canManagePmCases ||
                              isProjectOpenForCollaboration
                            ) {
                              dispatch(_onSetPmFormData(record));
                              dispatch(_toggleEditCaseState(true));

                              navigate(
                                `${dentalBasePath}/projects/details/case-registration/pm`,
                                {
                                  state: {
                                    caseId: record?.id,
                                    type: "pm",
                                    projectId: projectDetail?.id,
                                  },
                                }
                              );
                            } else return;
                          }
                        }}
                        src={dentalIcons.caseDetailIcon}
                        alt="Share"
                        style={{
                          cursor: "pointer",
                          paddingRight: 4,
                        }}
                      />
                    )}
                    {canManage ? (
                      <Popconfirm
                        placement="topLeft"
                        title="Are you sure to want to delete this Case ?"
                        okText="Yes"
                        cancelText="No"
                        onConfirm={() => onDeleteCase(record?.id)}
                        okButtonProps={{
                          style: {
                            backgroundColor: "#20c3ff",
                            border: "#20c3ff",
                          },
                        }}
                      >
                        <img
                          src={dentalIcons.caseDeleteIcon}
                          alt="Delete"
                          style={{ cursor: "pointer", paddingRight: 4 }}
                        />
                      </Popconfirm>
                    ) : (
                      <></>
                    )}
                  </div>
                );
              },
            },

            {
              title: <div className="custom_header_col">Add Record</div>,
              key: "recordAdded",
              align: "center",
              render: (text, record) => {
                const hasRecord = record?.records.length > 0;
                const isAmCase = record.case_type === "am";
                const isPmCase = record.case_type === "pm";
                const canManage =
                  (isAmCase && myInfo?.canManageAmCases) ||
                  (isPmCase && myInfo?.canManagePmCases) ||
                  isProjectOpenForCollaboration;
                return (
                  <>
                    <div
                      style={{
                        display: "flex",
                        gap: 10,
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={
                          hasRecord
                            ? dentalIcons.tickIcon
                            : dentalIcons.crossIcon
                        }
                      />
                      {hasRecord ? "Added" : "Missing"}
                    </div>

                    {!hasRecord && canManage ? (
                      <Row
                        justify={"start"}
                        style={{
                          justifyContent: "center",
                        }}
                      >
                        <CustomLinkButton
                          title={"Add Record"}
                          fontSize={12}
                          onClick={() => onAddDentalRecord(record)}
                        />
                      </Row>
                    ) : (
                      <></>
                    )}
                  </>
                );
              },
            },

            {
              title: <div className="custom_header_col">Edit Record</div>,
              dataIndex: "action",
              key: "action",
              render: (text, record) => {
                // Ensure correct destructuring: text, record
                const isAmCase = record.case_type === "am";
                const isPmCase = record.case_type === "pm";
                const canManage =
                  (isAmCase && myInfo?.canManageAmCases) ||
                  (isPmCase && myInfo?.canManagePmCases) ||
                  isProjectOpenForCollaboration;
                return (
                  <div
                    style={{
                      display: "flex",
                      gap: 10,
                      fontSize: 12,
                      color: "#20C3FF",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {record?.records.length > 0 && canManage ? (
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          onEditDentalRecord(record, record?.records);
                        }}
                      >
                        <img
                          src={dentalIcons.caseDetailIcon}
                          alt="Share"
                          style={{ cursor: "pointer", paddingRight: 4 }}
                        />
                      </div>
                    ) : (
                      "-"
                    )}
                  </div>
                );
              },
            },
          ]}
          pagination={false}
        />
      </div>
    );
  };
  const renderCollaboratorsTab = () => {
    const UpdatedCollaborators = projectDetail?.collaborators.filter(
      (collaborator) =>
        collaborator.name.toLowerCase().includes(searchExaminar.toLowerCase())
    );
    return (
      <div className="d-collaboratos_tab">
        <Row gutter={[10, 20]} justify={"space-between"}>
          <Col>
            <CustomSearchInput
              search={searchExaminar}
              onSearch={(e) => setSearchExaminar(e)}
            />
          </Col>
          {isPrimaryExaminer() && (
            <Col>
              <CustomPrimaryButton
                disabled={!isPrimaryExaminer()}
                title="Add Collaborator"
                width={100}
                icon={dentalIcons.rounderPlusIcon}
                onClick={() => setOpen(true)}
              />
            </Col>
          )}
        </Row>
        <br />
        <Table
          dataSource={UpdatedCollaborators}
          style={{ overflowX: "scroll" }}
          columns={[
            {
              title: "Name",
              dataIndex: "name",
              key: "name",
            },
            {
              title: (
                <div className="custom_header_col">AM Case Registered</div>
              ),
              // dataIndex: "amAdded",
              key: "amAdded",
              render: (text, record, index) => (
                <div className="center_align_digits">
                  {filterAmCaseAddedByACollaborator(
                    projectDetail?.cases,
                    projectDetail?.collaborators[index].id,
                    "am"
                  )}
                </div>
              ),
            },
            {
              title: (
                <div className="custom_header_col">PM Case Registered</div>
              ),
              key: "pmAdded",
              render: (text, record, index) => (
                <div className="center_align_digits">
                  {filterPmCaseAddedByACollaborator(
                    projectDetail?.cases,
                    projectDetail?.collaborators[index].id,
                    "pm"
                  )}
                </div>
              ),
            },
            {
              title: <div className="custom_header_col">AM Record Entered</div>,
              key: "amDentalAdded",
              render: (text, record) => (
                <div className="center_align_digits">
                  {filterAmPmDentalRecordAddedByCollaborator(
                    record?.id,
                    "am",
                    projectDetail?.cases
                  )}
                </div>
              ),
            },
            {
              title: <div className="custom_header_col">PM Record Entered</div>,
              key: "pmDentalAdded",
              render: (text, record) => (
                <div className="center_align_digits">
                  {filterAmPmDentalRecordAddedByCollaborator(
                    record?.id,
                    "pm",
                    projectDetail?.cases
                  )}
                </div>
              ),
            },
            {
              title: <div className="custom_header_col">Added Date</div>,
              key: "date",
              render: (text, record) => (
                <div className="center_align_digits">
                  {formateDateAndTime(record?.created_at)}
                </div>
              ),
            },
            ...(isPrimaryExaminer()
              ? [
                  {
                    title: "Actions",
                    dataIndex: "action",
                    key: "action",
                    render: (text, record) => {
                      // Ensure correct destructuring: text, record
                      return (
                        <Popconfirm
                          placement="topLeft"
                          title="Are you sure to want to delete this Examinar?"
                          okText="Yes"
                          cancelText="No"
                          onConfirm={() => remvoeCollaborator(record)}
                          okButtonProps={{
                            style: {
                              backgroundColor: "#20c3ff",
                              border: "#20c3ff",
                            },
                          }}
                          disabled={!isPrimaryExaminer()}
                        >
                          <div
                            style={{
                              display: "flex",
                              gap: 10,
                              fontSize: 12,
                              color: "#20C3FF",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <div
                              style={{
                                cursor:
                                  record?.examiner_type === "primary"
                                    ? "no-drop"
                                    : "",
                              }}
                            >
                              <img
                                src={dentalIcons.binIcon}
                                alt="Share"
                                style={{ paddingRight: 4 }}
                              />
                            </div>
                          </div>
                        </Popconfirm>
                      );
                    },
                  },
                ]
              : []),
          ]}
          pagination={false}
        />
      </div>
    );
  };
  const renderTraceabilityTab = () => {
    return <ProjectTraceability logs={projectDetail?.logs || []} />;
  };

  const handleOpenSingleCaseDetail = (record) => {
    setCaseDetailOpen(true);
    setCaseDetails(record);
  };

  const addCollaborator = async (item) => {
    setLoadingItemId(item.id);
    const payload = {
      project_id: projectDetail?.id,
      collaborators: [item.id],
    };
    await addCollaboratorToProject(payload);
  };
  const remvoeCollaborator = async (item) => {
    setLoadingItemId(item.id);
    const payload = {
      project_id: projectDetail?.id,
      collaborators: [item.id],
    };
    await remvoeCollaboratorFromProject(payload);
  };

  const addCollaboratorToProject = async (payload) => {
    try {
      const resposne = await onAddExaminarToProject({ payload: payload });
      if (resposne.status === 200) {
        message.success("Collaborator has been added");
        setLoadingItemId(null);
        await getProjectDetails();
      }
    } catch (error) {
      errorRequestHandel({ error });
    }
  };
  const remvoeCollaboratorFromProject = async (payload) => {
    try {
      const resposne = await onDeleteExaminarFromProject({
        payload: payload,
      });
      if (resposne.status === 200) {
        message.success("Collaborator has been removed");
        setLoadingItemId(null);
        await getProjectDetails();
      }
    } catch (error) {
      errorRequestHandel({ error });
    }
  };

  const onAddDentalRecord = (record) => {
    dispatch(_onClearDentalRecordData());
    dispatch(_onRecordUpdate(false));
    navigate(
      `${dentalBasePath}/projects/details/case/add-dental-record?project_id=${id}&case_id=${record?.id}&case_type=${record?.case_type}`
    );
  };
  const onEditDentalRecord = (record, records) => {
    const transfromData = transformServerDataToMarkedTeeth(records);
    const transformedQuadrants = transformQuadrantData(records);
    dispatch(_onRecordUpdate(true));

    dispatch(
      _onSetDentalRecordDataForUpdate(transfromData, transformedQuadrants)
    );
    navigate(
      `${dentalBasePath}/projects/details/case/add-dental-record?project_id=${id}&case_id=${record?.id}&case_type=${record?.case_type}`
    );
  };
  const changeProjectStatusAction = (status) => {
    //if (status === "completed" || status === "archived") {
    setModalOpen(true);
    //}
    setProjectStatusAction(status);
  };
  const onUpdateProjectStatus = async () => {
    try {
      const data = {
        project_id: projectDetail?.id,
        status: projectStatusAction, // open,closed,archived,completed
      };

      const response = await updateProjectStatus({ payload: data });
      if (response.status === 200) {
        message.success("Project status has been updated");
        await getProjectDetails();
        setModalOpen(false);
      }
    } catch (error) {
      errorRequestHandel({ error: error });
    }
  };

  const onDeleteCase = async (id) => {
    try {
      const response = await deleteAM_Or_PmCaseForCurrentProject({ id: id });
      if (response.status === 200) {
        message.success("Case has been deleted successfully");
        await getProjectDetails();
      }
    } catch (error) {
      errorRequestHandel({ error: error });
    }
  };

  return (
    <div className="d-project_details_container">
      <CustomSpiner loading={loading} />
      <CustomCard>
        <div className="project_details_body">
          <Row align={"middle"} justify={"space-between"}>
            <div className="project_details_body_status_and_title_section">
              <h6>{projectDetail?.title}</h6>
              <div
                className="project_details_body_status"
                style={{
                  background:
                    projectDetail?.incident_type == "closed_search"
                      ? "#FFA756"
                      : "#20c3ff",
                }}
              >
                <p>
                  {projectDetail?.incident_type === "closed_search"
                    ? "Closed Search"
                    : "Open Search"}
                </p>
              </div>
            </div>

            <div className="last_updated_section">
              {projectDetail?.simulation_date && (
                <div className="last_updated_section_content">
                  <p className="result_section_last_updated">Last Updated </p>
                  <p className="result_section_date_time">
                    {moment
                      .utc(projectDetail?.simulation_date)
                      .local()
                      .format("MMM DD, YYYY [at] h:mm A")}
                  </p>
                </div>
              )}
              <div style={{ width: 143 }}>
                <CustomDropdown
                  data={projectStatuses}
                  onSelect={(e) => {
                    changeProjectStatusAction(e);
                  }}
                  status={projectStatus}
                />
              </div>
            </div>
          </Row>
          <br />
          <Row gutter={[20, 20]}>
            <Col md={3}>
              <p className="project_detail_key">Project Code</p>
              <p className="project_detail_value">
                {getProjectCode(projectDetail?.id)}
              </p>
            </Col>
            <Col md={3}>
              <p className="project_detail_key">Date Created</p>
              <p className="project_detail_value">
                {formateDateAndTime(projectDetail?.created_at)}
              </p>
            </Col>
            <Col md={18}>
              <p className="project_detail_key">Description</p>
              <p className="project_detail_value">
                {projectDetail?.description}
              </p>
            </Col>
          </Row>
          <br />
          <br />
          <CustomFilter
            filtersData={filters}
            customClass={"custom-width"}
            selectedTab={selectedProjectDetailTab}
            onSelect={(value) => dispatch(_setProjectDetailsTab(value))}
          />
          <br />
          {renderCaseView(selectedProjectDetailTab)}
        </div>
      </CustomCard>
      <CustomDrawer
        open={open}
        onClose={() => setOpen(false)}
        title="Add Collaborators"
      >
        <AddCollaborator
          addCollaborator={(item) => addCollaborator(item)}
          remvoeCollaborator={(item) => remvoeCollaborator(item)}
          examinarsData={projectDetail?.collaborators}
          isLoading={loading}
          loadingItemId={loadingItemId}
        />
      </CustomDrawer>
      <CustomDrawer
        width={450}
        open={caseDetailOpen}
        onClose={() => setCaseDetailOpen(false)}
        title={`${
          caseDetails && caseDetails?.case_type.toUpperCase()
        } Case Details`}
      >
        <SingleCaseDetails caseDetails={caseDetails} />
      </CustomDrawer>
      <Modal
        open={isModalOpen}
        onCancel={() => setModalOpen(false)}
        closable
        centered
        closeIcon={
          <img src={dentalIcons.closeModal} style={{ color: "black" }} />
        }
        footer={null}
      >
        <ActionModal
          btnText={
            "Yes"
            // projectStatusAction === "completed"
            //   ? "Mark Completed"
            //   : projectStatusAction === "open"
            //   ? "Activate Project"
            //   : "Archive Project"
          }
          btnColor={
            projectStatusAction === "completed" ||
            projectStatusAction === "open"
              ? "#00AA55"
              : "#E8AD00"
          }
          icon={
            projectStatusAction === "completed"
              ? dentalIcons?.projectCompletedIcon
              : dentalIcons?.projectArchiveIcon
          }
          title={
            projectStatusAction === "completed"
              ? "Mark Project Completed"
              : projectStatusAction === "open"
              ? "Activate Project"
              : "Archive Project"
          }
          description={
            projectStatusAction === "completed"
              ? "Are you sure you want to mark this project completed?"
              : projectStatusAction === "open"
              ? "Are you sure you want to activate this project?"
              : "Are you sure you want to archive this project?"
          }
          onClick={onUpdateProjectStatus}
        />
      </Modal>
    </div>
  );
};

export default ProjectDetails;
